import React, { useEffect } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Box from "@mui/material/Box";
import ApiCommonContent from "../../services/GenericContent";
import ApiContent from "../../services/Content";

import "./styles.scss";
import { CommonContent, ContentKey, Language } from "../../types/Types";
import LinearProgress from "@mui/material/LinearProgress";
import {
  getSelectedLanguage,
  saveSelectedLanguage,
} from "../../services/Language";

type Props = {
  content: CommonContent[];
  onchangeLang: () => void
};

const RankingList = (props: Props) => {
  const [changeLang, setChangeLang] = React.useState(false);
  const [lang, setLang] = React.useState<Language>(getSelectedLanguage());
  const [commonContent, setCommonContent] = React.useState<
    CommonContent[] | undefined
  >(undefined);

  const refreshLanguage = async () =>{
    await  ApiContent.getContent(true);
    await  ApiCommonContent.getContent(true);
    setCommonContent(undefined);
    props.onchangeLang();
   }
 

  useEffect(() => {
    if (!commonContent) {
      ApiCommonContent.getContent().then((content) => {
        setCommonContent(content);
      });
    }
  },[commonContent]);


  useEffect(() => {
    if (changeLang) {
      setChangeLang(false);
      refreshLanguage().then().catch((e)=>{console.error(e)})
      
    }
  },[changeLang]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const lang = (event.target as HTMLInputElement).value as Language;
    saveSelectedLanguage(lang);
    setLang(lang);
    setChangeLang(true);
  };


  return (
    <Box>
      <FormControl>
        <FormLabel
          id="demo-radio-buttons-group-label"
          className="listItemTextLanguage"
        >
          {ApiCommonContent.getKeyValue(
            props.content,
            ContentKey.SELECT_LANGUAGE
          )}
        </FormLabel>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue={lang}
          name="radio-buttons-group"
          className="listRadioText"
          onChange={handleChange}
        >
          <FormControlLabel
            value="es"
            control={<Radio  disabled={lang === Language.ESPANISH} />}
            label="Español"
          />
          <FormControlLabel
            value="en"
            disabled={lang === Language.ENGLISH}
            control={<Radio />}
            label="English"
          />
          <FormControlLabel
            value="fr"
            disabled={lang === Language.FRENCH}
            control={<Radio />}
            label="French"
          />
        </RadioGroup>
      </FormControl>
      {changeLang && <LinearProgress />}
    </Box>
  );
};

export default RankingList;
